import { Pagination } from "antd";
import React, { useState, useEffect } from "react";
import TagManager from "react-gtm-module";
import { useHistory } from "react-router-dom";
import Accordion from "../../component/accordion";
import Searchfields from "../../component/search";
import Sidenav from "../../component/sidenav";
import "./dashboard.scss";

function Dashboard() {
  const history = useHistory();
  const query = useHistory().location.search;
  const urlSearchParams =  new URLSearchParams(query);
  const [loader, setloader] = useState(true);
  const [searchValue, setsearchValue] = useState("");
  const [response, SetResponse] = useState({
    pageCount: 0,
  });
  const [mapObjective, setMapObject] = useState({ pageCount: 0 });
  const [mapkeyResults, setMapkeyResults] = useState({ pageCount: 0 });
  const [mapType, setMapType] = useState("objectives");
  const [toggle, setToggle] = useState(false);
  const [pageDetails, setPageDetails] = useState({
    page: 1,
    pageSize: 10,
    search: "",
    userId: "",
    level: "",
    rocketship: "",
    lossableBet: "",
  });
  let { pageCount, data: userList } = response;
  if (mapType === 'objectives' && mapObjective?.data) {
    const { totalCount } = mapObjective?.data;
    pageCount = totalCount;
  } else if (mapType === 'keyResults' && mapkeyResults?.data) {
    const { totalCount } = mapkeyResults?.data;
    pageCount = totalCount;
  }
  const token = urlSearchParams.get("token");
  let isRocketship = urlSearchParams.has("rocketship") ? urlSearchParams.get("rocketship") : false;
  let isLossableBet = urlSearchParams.has("lossableBet") ? urlSearchParams.get("lossableBet") : false;

  const getUserList = (queryParams) => {
    fetch(`${process.env.REACT_APP_API_URL}${queryParams}&token=${token}`)
      .then((res) => res.json())
      .then((response) => {
        if (response?.statusCode && response?.statusCode === 402) {
          window.location.href = `/subscriptions?token=${token}`;
        } else {
          SetResponse(response);
        }
      })
      .catch((error) => {
        alert(error.message);
      });
  };

  const getMapListObjective = (queryParams) => {
    fetch(
      `${process.env.REACT_APP_API_URL}/objective${queryParams}&token=${token}`
    )
      .then((res) => res.json())
      .then((response) => {
        setMapObject(response);
      })
      .catch((error) => {
        alert(error.message);
      });
  };

  const getMapListkeyResults = (queryParams) => {
    fetch(
      `${process.env.REACT_APP_API_URL}/keyResults${queryParams}&token=${token}`
    )
      .then((res) => res.json())
      .then((response) => {
        setMapkeyResults(response);
      })
      .catch((error) => {
        alert(error.message);
      });
  };

  useEffect(() => {
    if (token) {
      const {
        page,
        pageSize,
        userId = "",
        search = "",
        level = "",
        rocketship = "",
        lossableBet = "",
      } = pageDetails;
      
      if (rocketship) {
        isRocketship = rocketship;
        isLossableBet = false;
      } else if (lossableBet) {
        isLossableBet = lossableBet;
        isRocketship = false;
      }
      if (pageDetails.page && pageDetails.pageSize) {
        getUserList(
          `?page=${page}&limit=${pageSize}&user=${userId}&search=${search}&level=${level}&rocketship=${isRocketship}&lossableBet=${isLossableBet}`
        );
      }
      getMapListObjective(
        `?page=${page}&limit=${pageSize}&user=${userId}&search=${search}&level=${level}&rocketship=${isRocketship}&lossableBet=${isLossableBet}`
      );
      getMapListkeyResults(
        `?page=${page}&limit=${pageSize}&user=${userId}&search=${search}&level=${level}&rocketship=${isRocketship}&lossableBet=${isLossableBet}`
      );
    } else {
      history.push("/not-found");
    }
    setloader(false);
  }, [query, pageDetails]);

  const handleSearch = (e) => {
    if (e.target.value) {
      const filterValue = e.target.value;
      setsearchValue(filterValue);
    } else {
      setsearchValue("");
      setPageDetails({ ...pageDetails, search: "" });
    }
  };

  const handleSearchuser = () => {
    setPageDetails({ ...pageDetails, search: searchValue });
    const dataLayer = {
      event: "Filter",
      event_category: "Search",
      event_id: searchValue,
    };
    TagManager.dataLayer({ dataLayer });
  };

  const handlePageChange = (page, pageSize) => {
    setPageDetails({
      ...pageDetails,
      page,
      pageSize,
    });
  };

  const handlePageRefresh = (page, pageSize) => {
    setPageDetails({
      ...pageDetails,
      page,
      pageSize,
    });
  };

  const handleSelect = (userId) => {
    setPageDetails({ ...pageDetails, userId: userId ? userId : "" });
    const dataLayer = {
      event: "Filter",
      event_category: "User",
      event_id: userId ? userId : "",
    };
    TagManager.dataLayer({ dataLayer });
  };

  const handleLevelselect = (level) => {
    setPageDetails({ ...pageDetails, level: level ? level : "" });
    const dataLayer = {
      event: "Filter",
      event_category: "Level Of Hierarchy",
      event_id: level ? level : "",
    };
    TagManager.dataLayer({ dataLayer });
  };

  const handleSpotlight = (value, event) => {
    const oValue = value === "rocketship" ? "lossableBet" : "rocketship";
    setPageDetails({ ...pageDetails, [value]: event.keyValue, [oValue]: "" });
    const dataLayer = {
      event: "Filter",
      event_category: event.children,
      event_id: event.keyValue,
    };
    TagManager.dataLayer({ dataLayer });
  };

  const handleToggle = (event) => {
    setToggle(event);
    setPageDetails({ ...pageDetails, page: 1});
    setMapType('objectives');
  };

  const handleMapValue = (event) => {
    setMapType(event);
    setPageDetails({ ...pageDetails, page: 1});
  };

  return (
    <div className="d-flex  ">
      <Sidenav />
      <div className="flex-1 details-section">
        <div className="container">
          <Searchfields
            toggle={toggle}
            placeholder="Search for OKRs"
            handleSearch={handleSearch}
            handleSearchuser={handleSearchuser}
            handleSelect={handleSelect}
            handleLevelselect={handleLevelselect}
            handleToggle={handleToggle}
            handleMapValue={handleMapValue}
            handleSpotlight={handleSpotlight}
          />
          <div>
            <Accordion
              mapType={mapType}
              toggle={toggle}
              loader={loader}
              userList={userList}
              mapObjective={mapObjective}
              mapkeyResults={mapkeyResults}
              pageRefresh={handlePageRefresh}
              page={pageDetails.page}
              pageSize={pageDetails.pageSize}
            />
          </div>
        </div>
        {/* {!toggle ? ( */}
        <Pagination
          onChange={handlePageChange}
          defaultCurrent={1}
          current={pageDetails.page}
          pageSize={pageDetails.pageSize}
          total={pageCount}
          showSizeChanger
          pageSizeOptions={[5, 10, 20]}
        />
        {/* ) : (
          <></>
        )} */}
      </div>
    </div>
  );
}

export default Dashboard;
